import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import AllInputs from '../../../../inputs/AllInputs';

const CheckboxesTab = ({ tab, userStamp, vehicle_id }) => {
  // Select state from Redux
  const vehicle = useSelector((state) => state.settings_refresh.active_vehicle);
  const vehicle_properties = useSelector(
    (state) => state.settings_refresh.active_vehicle?.vehicle_properties || [],
  );
  const installation = useSelector((state) => state.settings_dealerships.installation);
  const vehicle_columns = useSelector((state) => state.settings_departments.vehicle_columns || []);
  const current_user = useSelector((state) => state.current_user);

  // Local state for form inputs
  const [formData, setFormData] = useState({});

  // Handle input changes
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const tabData = _.find(useSelector((state) => state.settings_site.all_tabs || []), { name: tab }) || {};
  const tab_properties = tabData.tab_properties || [];

  return (
    <div className="container checkboxes-tab-container">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6">
          <div className="card shadow-sm p-4 mb-4">
            <div className="card-body text-center">
              {tab_properties
                .slice()
                .sort((a, b) => a.order - b.order) // Sort by order
                .filter((tab_property) => {
                  const dealership = tab_property.dealership || '';
                  const subdomain = installation?.subdomain;
                  return !subdomain || dealership.split(',').includes(subdomain);
                })
                .map((tab_property) => {
                  const vehicle_column =
                    _.find(vehicle_columns, { id: tab_property.vehicle_column_id }) || {};

                  if (!vehicle_column || Object.keys(vehicle_column).length === 0) {
                    return null;
                  }

                  const colObject = _.find(vehicle_properties, { key: vehicle_column.name }) || {};
                  const inputType = vehicle_column.input_name?.toLowerCase() || 'text';
                  const inputClass =
                    inputType === 'checkbox' ? 'form-check-input' :
                    inputType === 'select' ? 'form-select' : 'form-control';

                  const label = vehicle_column.display_name !== '' ? <label className="form-label fw-bold">{vehicle_column.display_name}</label> : <label className="form-label fw-bold text-capitalize">{vehicle_column.name}</label>;

                  return (
                    <div key={`tab_property_${tab_property.id}`} className="card w-100 mb-3">
                      <div className="card-body">
                        <h5 className="card-title">
                          <label className="form-label fw-bold text-capitalize">
                            {label}
                          </label>
                        </h5>
                        <AllInputs
                          name={vehicle_column.name}
                          label={vehicle_column.name}
                          display_label_1={vehicle_column.display_label_1}
                          display_label_2={vehicle_column.display_label_2}
                          onChange={onChange}
                          user_name={colObject.user_name || ''}
                          value={colObject.value || ''}
                          type={vehicle_column.input_name}
                          options={vehicle_column.options}
                          checked={colObject.value || ''}
                          parentid={vehicle_id}
                          rowid={colObject.id || ''}
                          uid={colObject.uid || ''}
                          updated_at={colObject.updated_at || undefined}
                          updatetype="vehicleproperty"
                          icon={vehicle_column.icon}
                          userStamp={userStamp}
                          setdisabled={false}
                          vehicle={vehicle}
                          className={inputClass}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckboxesTab;